import type { GrindType } from "@shared/types";

// From client-shared/src/lib/constants.ts
export const REQUIRED_GRIND: GrindType = "Whole bean";

// From client ProductSelectModal.tsx (lines ~30-40)
export const REQUIRED_FIELDS = [
  "brewMethod",
  "description",
  "imageUploads",
  "mainFlavorCategory",
  "productType",
  "roastLevel",
  "secondaryFlavorCategory",
  "tastingNotes",
  "title",
  "roasterNotes",
] as const;

export const REQUIRED_VARIANT_FIELDS = [
  "bagSize",
  "grind",
  "price",
  "weeklyInventory",
  "wholesalePrice",
  "term",
  "startDate",
  "isProductSelectedForImport",
] as const;

// From ProductForm.tsx (lines ~26-30)
export const DEFAULT_START_ELEVATION = 1500;
export const DEFAULT_END_ELEVATION = 2500;
export const DEFAULT_MIN_ELEVATION = 500;
export const DEFAULT_MAX_ELEVATION = 3000;
export const DEFAULT_MIN_ELEVATION_STEP = 50;

// From SingleVariantForm.tsx (lines ~55-56)
export const MINIMUM_END_OF_STOCK_DATE_DAYS = 7 * 4; // 4 weeks
export const MAXIMUM_END_OF_STOCK_DATE_DAYS = 30 * 6; // 6 months

// Max length defaults (from client-shared constants.ts lines ~361-363)
export const DEFAULT_TITLE_MAX_LENGTH = 40;
export const DEFAULT_DESCRIPTION_MAX_LENGTH = 65000;
export const DEFAULT_ROASTER_NOTE_MAX_LENGTH = 500;

// Selection cap for the Badges multi-select (ProductForm.tsx)
export const MAX_BADGES_SELECTION = 10;

// Radix Select rejects an empty-string item value, so the Character dropdown's
// "None" (clear) item uses this sentinel and the form maps it back to "".
export const NO_CHARACTER_VALUE = "__none__";
